import { useLocation, Link, Outlet, useNavigate } from "react-router-dom";
import { Drawer } from "antd";
import { useEffect, useState } from "react";
import styles from "./dashboardLayout.module.scss";
import { ReactComponent as Logo } from "../../assets/autoloadslogo-light 1.svg";
import { ReactComponent as LogoDark } from "../../assets/autoloadslogo-light 1.svg";
import { ReactComponent as Grid } from "../../assets/grid.svg";
import { ReactComponent as Chat } from "../../assets/chat.svg";
import { ReactComponent as List } from "../../assets/list.svg";
import { ReactComponent as Calendar } from "../../assets/calendar.svg";
import { ReactComponent as Money } from "../../assets/money.svg";
import { ReactComponent as Gear } from "../../assets/gear.svg";
import { ReactComponent as Help } from "../../assets/help.svg";
import { ReactComponent as Message } from "../../assets/message.svg";
import { ReactComponent as ProfileLogo } from "../../assets/profile-logo.svg";
import { ReactComponent as Menu } from "../../assets/menu.svg";
import { ReactComponent as Signout } from "../../assets/logout.svg";
import { ReactComponent as Collapse } from "../../assets/collapse.svg";
import { useAtom } from "jotai";
import { userData } from "../../state";
import { logout } from "../../utils/logout";

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const [user] = useAtom(userData);
  const navigate = useNavigate();

   // Automatically logout when token expires
   useEffect(() => {
    if (user?.expires_in) {
      const expirationTime = user.expires_in * 1000; // Convert to milliseconds
      const logoutTimer = setTimeout(() => {
        logout(); // Auto logout when token expires
        navigate("/signIn"); // Redirect to the login page
      }, expirationTime);

      return () => clearTimeout(logoutTimer); // Cleanup the timer on unmount or user change
    }
  }, [user, navigate]);

  const homeLinks = [
    { label: "Overview", path: "/dashboard", icon: <Grid /> },
    { label: "Load List", path: "/load-list", icon: <Calendar /> },
    { label: "My Trucks", path: "/myTrucks", icon: <List /> },
    { label: "My Drivers", path: "/myDrivers", icon: <Money /> },
  ];

  const preferenceLinks = [
    { label: "Settings", path: "/settings", icon: <Gear /> },
    { label: "Help", path: "/help", icon: <Help /> },
  ];

  return (
    <div className={styles.main}>
      <nav className={styles.sidebar}>
        <Logo />
        <section>
          <h4 className={styles.heading}>Home</h4>
          <div className={styles.menu}>
            {homeLinks.map((item) => (
              <Link
                to={item.path}
                key={item.path}
                className={`${styles.menuItem} ${
                  location.pathname === item.path ? styles.active : ""
                }`}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </section>
        <div className="divider"></div>
        <section>
          <h4 className={styles.headingPreference}>Preferences</h4>
          <div className={styles.menu}>
            {preferenceLinks.map((item) => (
              <Link
                to={item.path}
                key={item.path}
                className={`${styles.menuItem} ${
                  location.pathname === item.path ? styles.active : ""
                }`}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </section>
        <button
          className={styles.menuCollapse}
          onClick={logout}
        >
           <Signout />
          <span>Logout</span>
        </button>
        <button
          className={styles.menuCollapse}
          onClick={() => setSidebarOpen(false)}
        >
          <Collapse />
          <span>Collapse menu</span>
        </button>
      </nav>
      <div className={styles.headerPlusContent}>
        <header className={styles.header}>
          <div className={styles.space}>
            <Menu
              className={styles.hamburger}
              onClick={() => setSidebarOpen(true)}
            />
            <LogoDark className={styles.logoDark} />
            <div className={styles.headerTitle}>
              <div className={styles.badge}>{user?.user?.name || "Company Module"}</div>
            </div>
          </div>
          <div className={styles.spaceHeader}>
            <Message />
            <ProfileLogo onClick={() => navigate("/view-profile")} />
          </div>
        </header>
        <div className={styles.outletWrapper}>
          <Outlet />
        </div>
      </div>
      <Drawer
        placement="left"
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        styles={{
          header: { display: "none" },
          content: {
            backgroundColor: "#121A26",
            color: "#fff",
          },
          body: {
            display: "flex",
            flexDirection: "column",
          },
        }}
        width={247}
      >
        <Logo />
        <section>
          <h4 className={styles.heading}>Home</h4>
          <div className={styles.menu}>
            {homeLinks.map((item) => (
              <Link
                to={item.path}
                key={item.path}
                className={`${styles.menuItem} ${
                  location.pathname === item.path ? styles.active : ""
                }`}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </section>
        <div className="divider"></div>
        <section>
          <h4 className={styles.heading}>Preferences</h4>
          <div className={styles.menu}>
            {preferenceLinks.map((item) => (
              <Link
                to={item.path}
                key={item.path}
                className={`${styles.menuItem} ${
                  location.pathname === item.path ? styles.active : ""
                }`}
              >
                {item.icon}
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </section>
        <button
          className={styles.menuCollapse}
          onClick={logout}
        >
         <Signout />
         <span>Logout</span>
        </button>
        <button
          className={styles.menuCollapse}
          onClick={() => setSidebarOpen(false)}
        >
          <Collapse />
          <span>Collapse menu</span>
        </button>
      </Drawer>
    </div>
  );
}
